import React from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import useCollectorPhotoSource from 'hooks/useCollectorPhotoSource';

const Item = React.memo(
	({
		description = '',
		original,
		originalAlt = '',
		coords,
		photoId,
		active = true,
	}) => {
		const itemSrc = useCollectorPhotoSource({
			photoId,
			variant: 'original',
			src: original,
			active,
		});
		return (
			<TransformWrapper>
				<TransformComponent
					wrapperStyle={{
						height: '100%',
						width: '100%',
						position: 'relative',
					}}
					contentStyle={{ width: '100%' }}
				>
					<img
						className='image-gallery-image'
						src={itemSrc}
						alt={originalAlt}
					/>
					{description && (
						<span className='image-gallery-description'>{description}</span>
					)}
				</TransformComponent>
			</TransformWrapper>
		);
	},
);

export default Item;
